/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DecimalValueValidationModel
 */
export interface DecimalValueValidationModel {
    /**
     * 
     * @type {number}
     * @memberof DecimalValueValidationModel
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof DecimalValueValidationModel
     */
    max?: number;
}

/**
 * Check if a given object implements the DecimalValueValidationModel interface.
 */
export function instanceOfDecimalValueValidationModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DecimalValueValidationModelFromJSON(json: any): DecimalValueValidationModel {
    return DecimalValueValidationModelFromJSONTyped(json, false);
}

export function DecimalValueValidationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecimalValueValidationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
    };
}

export function DecimalValueValidationModelToJSON(value?: DecimalValueValidationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min': value.min,
        'max': value.max,
    };
}

